module.exports = __webpack_public_path__ + "src/img/artist/work05_3.jpg?74795e7d4c733d4aa0968697d8629221";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work05_3.jpg
// module id = 156
// module chunks = 0